import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { AppState } from '../../../app/app.global';

import { HttpService } from '../../../providers/service/httpservice';
import { StorageService } from '../../../providers/service/storageservice';
import { SELECT_MSG_CATEGORY} from '../../../providers/config/serviceurl';

@Component({
  selector: 'page-msg-setting',
  templateUrl: 'msg-setting.html',
})
export class MsgSettingPage {
  settingList = [];
  settingListCache:any = [];
  user:any;
  callback;
  constructor(public navCtrl: NavController, public navParams: NavParams, private httpService:HttpService,public global: AppState) {
    this.user = StorageService.getObj('currentUser');
    if(localStorage.getItem('msgSettingListCache')){
      this.settingListCache = JSON.parse(localStorage.getItem('msgSettingListCache'));
    }
    this.loadSettingList();
    this.callback = this.navParams.get("callback");
    
  }
  //离开页面时触发
  ionViewWillLeave(){
    //返回消息列表
		let param = 'msgSettingListCache';
		this.callback(param).then(()=>{
		});
  }

  //加载消息分类列表
  loadSettingList(){
    let params = {'username':this.user.xgh};
		this.httpService.get2(SELECT_MSG_CATEGORY,params).then(anyObj =>this.handlegetMsgTypes(anyObj));
  }
  
	handlegetMsgTypes(obj:any){
		if(obj != null && obj != undefined && obj.items != null && obj.items != undefined){
      const items = obj.items;
      for (let index = 0; index < items.length; index++) {
        let id = items[index].ID;
        let name = items[index].NAME;
        let typeItem = {'id':id,'state':true, "name": name};
        for (let i = 0; i < this.settingListCache.length; i++) {
          if(this.settingListCache[i].id == id){
            typeItem.state = this.settingListCache[i].state;
          }
        }
        this.settingList.push(typeItem);
      }
      //localStorage.setItem('msgSettingListCache',JSON.stringify(this.settingList));
		  }
	}

  toggle(e:any ,index:any){
    this.settingList[index].state = e.checked;
    localStorage.setItem('msgSettingListCache',JSON.stringify(this.settingList));
  }

}



// WEBPACK FOOTER //
// ./src/pages/message/msg-setting/msg-setting.ts